const $ = jQuery;
const $window = $(window);

const initOverlay = () => {
  const els = once('search-overlay', '.oh-main-search');
  els.forEach((el) => {
    const searchIcon = $(el);
    const closeIcon = $('.os-close');
    const body = $('body');
    const searchOverlay = $('.om-search');

    searchIcon.click(() => {
      body.addClass('os-active');
      searchOverlay.show();
    });

    closeIcon.click(() => {
      body.removeClass('os-active');
      searchOverlay.hide();
    });
  });
};

$window.on('load', () => initOverlay());
